export enum SERVER_REQUEST_ERRORS {
  NOT_FOUND,
  INTERNAL
}

export function GetServerRequestError(status: number) : SERVER_REQUEST_ERRORS {
    if(status === 404) return SERVER_REQUEST_ERRORS.NOT_FOUND;
    if(status === 500) return SERVER_REQUEST_ERRORS.INTERNAL;
}